// extracted by mini-css-extract-plugin
module.exports = {"list":"ServiceList_list__3aYen","badges":"ServiceList_badges__1PNGh","load":"ServiceList_load__2YDSa"};